export const BiDashboardConstants = {
  title: "BI Dashboard",
  category: "Category",
  dashboard: "Dashboard",
  noDashboardsAvailable: "No dashboards available",
  biDashboard : "bi-dashboard",
};

export const embedDashboardConstants = {
  mountPointNotFound: "Dashboard container not found.",
  iframeTitle: "Embedded Preset Dashboard",
  referrerPolicy: "no-referrer-when-downgrade",
  embedFailed: "Failed to embed dashboard:",
};
